import { derived, get } from "svelte/store"
import { notificationData } from "./notifications-data"

// This file handles that popup above the lesson to prompt you for the next day

export type NextLessonPromptInfo = {
    cancelAction: () => Promise<void>
    nextAction: () => Promise<void>
    cancelMessage: string
    nextMessage: string
    readyMessage: string
    /**
     * Lesson 365 or Epilogue and has ready the epilogue
     */
    totallyDone: boolean
}

/**
 * Retrieve information for the next lesson and determine if it should be shown.
 * Null if should not be shown. Depends on the current lesson number and also
 * whether the reading list for this lesson is completed
 */
export const nextLessonInfo = derived(notificationData, (notfData) => {
    if (notfData === null) return null
    const epilogueDay = notfData.currentLesson === 366
    if (epilogueDay) return null

    const epilogueRead = !!notfData.getItem(366).doneList.length
    const lastLesson = notfData.currentLesson === 365

    const nextLesson = notfData.currentLesson + 1
    let readyMessage = "Are you ready for your next lesson?"
    let nextMessage = `Start Lesson ${nextLesson}`
    let nextAction = () => {
        const live = get(notfData.live)
        return live.gotoNextLesson()
    }

    const cancelAction = () => notfData.resetDay()
    let cancelMessage = `Stay on ${notfData.currentLesson === 0 ? `Introduction` : `Lesson ${notfData.currentLesson}`}`

    if (lastLesson) {
        // Epilogue is NOT read
        readyMessage = "Ready to read the Epilogue?"
        nextMessage = `Read Epilogue`
        if (epilogueRead) {
            // Absolute last lesson, can't go forward or error!
            readyMessage = "Finished the final lesson?"
            nextMessage = "Done"
            nextAction = async () => {
                const live = get(notfData.live)
                if (!epilogueDay) await live.gotoNextLesson()
                // celebrateWorkbook() // TODO <--- try to fix this?
            }
            cancelMessage = `Stay on lesson 365`
        }
    }

    return {
        nextAction,
        nextMessage,
        readyMessage,
        cancelAction,
        cancelMessage,
        totallyDone: notfData.currentLesson >= 365 && epilogueRead,
    } as NextLessonPromptInfo
})
